var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 0.333496C3.81301 0.333496 0.833008 3.3135 0.833008 7.00016C0.833008 10.6868 3.81301 13.6668 7.49967 13.6668C11.1863 13.6668 14.1663 10.6868 14.1663 7.00016C14.1663 3.3135 11.1863 0.333496 7.49967 0.333496ZM10.3663 9.86683C10.1063 10.1268 9.68634 10.1268 9.42634 9.86683L7.49967 7.94016L5.57301 9.86683C5.31301 10.1268 4.89301 10.1268 4.63301 9.86683C4.37301 9.60683 4.37301 9.18683 4.63301 8.92683L6.55967 7.00016L4.63301 5.0735C4.37301 4.8135 4.37301 4.3935 4.63301 4.1335C4.89301 3.8735 5.31301 3.8735 5.57301 4.1335L7.49967 6.06016L9.42634 4.1335C9.68634 3.8735 10.1063 3.8735 10.3663 4.1335C10.6263 4.3935 10.6263 4.8135 10.3663 5.0735L8.43967 7.00016L10.3663 8.92683C10.6197 9.18016 10.6197 9.60683 10.3663 9.86683Z",
    fill: "#C81919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/RejectedIcon.4120d01f4122eabda6c3248ecfddb2e6.svg";
export { ForwardRef as ReactComponent };